import { useMemo } from 'react';

import { Country } from '@dreryk/address-common-api';

import { getCurrentLocale } from '@dreryk/react-common';

export const useCountries = (): Country[] => {
   return useMemo(() => {
      const locale = getCurrentLocale();
      return Country.searchAll(locale);
   }, []);
};
